module.exports = __webpack_public_path__ + "img/send.c8e6685b.svg";